import React from "react";
import styles from "./User.module.css";
import { Link, useParams } from "react-router-dom";
import Loader from "../../../components/Loader";
import { client } from "../../../utils/api-client";
import ButtonLink from "../../../components/ButtonLink";
import { useTranslation } from "react-i18next";
import Avatar from "../../../components/Avatar.js";
import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import { useNavigate } from "react-router-dom";

const User = () => {
  const [userLoaded, setUserLoaded] = React.useState(false);
  const [user, setUser] = React.useState();
  const params = useParams();
  const [userId] = React.useState(params.userId);
  const [showConfirmationModal, setShowConfirmationModal] =
    React.useState(false);
  const [confirmDeleteUser, setConfirmDeleteUser] = React.useState(null);
  const { t } = useTranslation();
  let navigate = useNavigate();

  React.useEffect(() => {
    client(`users/${userId}.json`).then((responseData) => {
      setUser(responseData);
      console.log(responseData);
      setUserLoaded(true);
    });
  }, [userId]);

  const handleDeleteUser = (userId) => {
    setConfirmDeleteUser(userId);
    setShowConfirmationModal(true);
  };

  const deleteUser = () => {
    client(`users/${confirmDeleteUser}.json`, {
      method: "DELETE",
    })
      .then(() => {
        setConfirmDeleteUser(null);
        setShowConfirmationModal(false);
        navigate("/admin/users");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>
      {userLoaded ? (
        <div className={styles.container}>
          <div className={styles.nav}>
            <Link to={"/admin/users"} className={styles.link}>
              Atrás
            </Link>
            <div>
              <Button
                secondary
                small
                className={styles.navButton}
                onClick={() => handleDeleteUser(user.user_id)}
              >
                {t("admin.user.delete")}
              </Button>
              <ButtonLink
                secondary
                small
                className={styles.navButton}
                to="edit"
              >
                {t("admin.user.edit")}
              </ButtonLink>
            </div>
          </div>
          <div className={styles.overview}>
            <Avatar
              initial={user.first_name.charAt(0)}
              className={styles.avatar}
              size="lg"
            />
            <h3 className={styles.h3}>{`${user.display_name}`}</h3>
          </div>
          <form className={styles.form}>
            <label className={styles.label}>{t("admin.user.fullName")}</label>
            <input
              className={styles.field}
              type="text"
              value={user.full_name}
              disabled={true}
              name="full_name"
            />
            <label className={styles.label}>{t("admin.user.email")}</label>
            <input
              className={styles.field}
              type="text"
              value={user.email}
              disabled={true}
              name="email"
            />
            <label className={styles.label}>{t("admin.user.membership")}</label>
            <input
              className={styles.field}
              type="text"
              value={user.membership}
              disabled={true}
              name="membership"
            />
            <label className={styles.label}>{t("admin.user.dob")}</label>
            <input
              className={styles.field}
              type="text"
              value={user.birthday}
              disabled={true}
              name="birthday"
            />
            <div className={styles.formGroup}>
              <div>
                <label className={styles.label}>{t("admin.user.ghin")}</label>
                <input
                  className={styles.field}
                  type="text"
                  value={user.ghin}
                  disabled={true}
                  name="ghin"
                />
              </div>
              <div>
                <label className={styles.label}>{t("admin.user.hcp")}</label>
                <input
                  className={styles.field}
                  type="text"
                  value={user.hi}
                  disabled={true}
                  name="hcp"
                />
              </div>
            </div>
            <label className={styles.label}>{t("admin.user.status")}</label>
            <input
              className={styles.field}
              type="text"
              value={user.status}
              disabled={true}
              name="status"
            />
          </form>
        </div>
      ) : (
        <Loader />
      )}
      <Modal
        show={showConfirmationModal}
        onClose={() => {
          setShowConfirmationModal(false);
        }}
      >
        <>
          <h3 className={styles.h3}>Eliminar usuario</h3>
          <p>¿Estas seguro que deseas eliminar a este usuario del sistema?</p>
          <Button block onClick={deleteUser}>
            Eliminar
          </Button>
        </>
      </Modal>
    </div>
  );
};

export default User;
